import { calcRem } from '@the-game/components/utils'
import styled from '@emotion/styled'

export const FormControl = styled('div')(({ theme }) => ({
    marginBottom: calcRem(theme.spacing.xs),
}))

export default FormControl
